var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49373 0.686265C2.1032 0.295741 1.47004 0.295741 1.07951 0.686265C0.68899 1.07679 0.68899 1.70995 1.07951 2.10048L2.49373 0.686265ZM22.9998 23.6066C23.5521 23.6066 23.9998 23.1589 23.9998 22.6066L23.9998 13.6066C23.9998 13.0543 23.5521 12.6066 22.9998 12.6066C22.4475 12.6066 21.9998 13.0543 21.9998 13.6066L21.9998 21.6066L13.9998 21.6066C13.4475 21.6066 12.9998 22.0543 12.9998 22.6066C12.9998 23.1589 13.4475 23.6066 13.9998 23.6066L22.9998 23.6066ZM1.07951 2.10048L22.2927 23.3137L23.7069 21.8995L2.49373 0.686265L1.07951 2.10048Z",
    fill: "#3462C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow);
export default __webpack_public_path__ + "static/media/row.d18efa36bb7a2a7dd47dcafebdebe3ac.svg";
export { ForwardRef as ReactComponent };